import React, { useState } from 'react';
import NicknameInput from './NicknameInput';

const HomePage = ({ nickname, onNicknameChange }) => {
  const [showNicknameInput, setShowNicknameInput] = useState(false);
  
  const handleNicknameSet = (newNickname) => {
    setShowNicknameInput(false);
    if (onNicknameChange) {
      onNicknameChange(newNickname);
    }
  };
  
  if (showNicknameInput) {
    return <NicknameInput onNicknameSet={handleNicknameSet} />;
  }
  return (
    <div style={{ 
      backgroundColor: '#000',
      minHeight: '100vh',
      color: '#fff',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <h1 style={{ fontSize: '48px', marginBottom: '20px' }}>La Bomba Hombre</h1>
      {nickname && (
        <p style={{ fontSize: '18px', marginBottom: '20px', color: '#4a9eff' }}>
          Welcome, {nickname}!
        </p>
      )}
      <div style={{ margin: '40px 0', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
        <button 
          onClick={() => window.location.href = '/multiplayer'}
          style={{
            padding: '20px 40px',
            fontSize: '24px',
            backgroundColor: '#e14141',
            color: 'white',
            border: 'none',
            borderRadius: '10px',
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(225, 65, 65, 0.3)',
            transition: 'transform 0.2s, box-shadow 0.2s'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'scale(1.05)';
            e.target.style.boxShadow = '0 6px 20px rgba(225, 65, 65, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'scale(1)';
            e.target.style.boxShadow = '0 4px 12px rgba(225, 65, 65, 0.3)';
          }}
        >
          Create New Game
        </button>
        
        {nickname && (
          <button 
            onClick={() => setShowNicknameInput(true)}
            style={{
              padding: '12px 24px',
              fontSize: '16px',
              backgroundColor: '#4a9eff',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(74, 158, 255, 0.3)',
              transition: 'transform 0.2s, box-shadow 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'scale(1.05)';
              e.target.style.boxShadow = '0 6px 20px rgba(74, 158, 255, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1)';
              e.target.style.boxShadow = '0 4px 12px rgba(74, 158, 255, 0.3)';
            }}
          >
            Change Nickname
          </button>
        )}
      </div>
      <div style={{ marginTop: '40px', fontSize: '16px', color: '#888' }}>
        <p>Or join an existing game by visiting: <strong style={{ color: '#4a9eff' }}>bomberman.kudlacep.dev/game/ROOMID</strong></p>
      </div>
    </div>
  );
};

export default HomePage;